import { isDOMMutationError, isDynamicLoadError } from '@shared/utils'

import useFormatMessage from '@hooks/useFormatMessage'
import ErrorBase from '@components/ErrorBase'

import AppUpdated from './AppUpdated'
import DOMMutation from './DOMMutation'

/**
 * Error component handles different types of errors and displays appropriate messages.
 *
 * @param {object} props - The component props.
 * @param {number} [props.code=500] - The error code.
 * @param {Error|string} props.error - The error object or message.
 * @param {function} props.resetErrorBoundary - Function to reset the error boundary.
 * @returns {JSX.Element} The Error component.
 */
export default function Error({ code = 500, error, resetErrorBoundary }) {
  const formatMessage = useFormatMessage()

  if (isDynamicLoadError(error)) return <AppUpdated />
  if (isDOMMutationError(error)) return <DOMMutation />

  return (
    <ErrorBase
      title={formatMessage('error.general.title')}
      subtitle={formatMessage('error.general.message')}
      code={code}
      error={error}
      reset={resetErrorBoundary}
    />
  )
}
